module.exports = __webpack_public_path__ + "img/success.77752dad.png";